import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import ApiUrls from "../../../constants/ApiUrls";
import CacheTime from "../../../constants/CacheTime";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import { getFromCacheByKey } from "../../../utilites/cache";
import { isCheckoutSimOnly } from "../../../utilites/order";
import { apiRequest } from "../api/actions";
import { setApiResponseInCache } from "../cache/actions";
import { setCaptchaRequiredActions } from "../captcha/actions";
import { createErrorNotification } from "../notification/actions";
import { getSessionData } from "../sessionData/actions";
import { setAvailabilityProduct, setAvailabilityProductLoader } from "./actions";

const availabilityMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.AVAILABILITY_PRODUCT.GET:
    const { manhattanOrder } = store.getState();

    const isSimOnly = isCheckoutSimOnly(manhattanOrder.order);
    const availabilityProduct = getFromCacheByKey(
      MiddlewareEntities.AVAILABILITY_PRODUCT + JSON.stringify(action.params)
    );

    if (availabilityProduct) {
      return next(setAvailabilityProduct(availabilityProduct));
    }
    // for sim only firstly true and then false fix
    next(setAvailabilityProductLoader(true));

    if (!isSimOnly) {
      next(apiRequest(
        null,
        'GET', `${ApiUrls.STORES}/store`,
        { ...action.params },
        null,
        MiddlewareEntities.AVAILABILITY_PRODUCT,
        {}),
      );
    } else {
      next(setAvailabilityProductLoader(false));
    }
    break;
  case `${MiddlewareEntities.AVAILABILITY_PRODUCT} ${ActionTypes.API_SUCCESS}` :
    next(setAvailabilityProduct(action.payload.data.availabilityProduct));
    next(getSessionData(action.payload.data.session));
    next(setAvailabilityProductLoader(false));
    next(setCaptchaRequiredActions(false, MiddlewareEntities.AVAILABILITY_PRODUCT));
    next(setApiResponseInCache(
      MiddlewareEntities.AVAILABILITY_PRODUCT + JSON.stringify(action.payload.meta.params),
      action.payload.data.availabilityProduct,
      CacheTime.AVAILABILITY_PRODUCT)
    );
    break;
  case `${MiddlewareEntities.AVAILABILITY_PRODUCT} ${ActionTypes.API_ERROR}` :
    next(createErrorNotification(action.payload.data, MiddlewareEntities.AVAILABILITY_PRODUCT));
    next(setAvailabilityProductLoader(false));
  }
};

export default availabilityMiddleware;

